import Api from './api'
import { isEmpty } from '../../../utils'

export const departmentProps = {
  select: String,
  userApi: {
    type: Object,
    default: () => {
      return {
        orgLazyLoadList: Api.orgLazyLoadList,
        orgFilter: Api.orgFilter,
        departmentListByIdsOrCodes: Api.departmentListByIdsOrCodes
      }
    }
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  // 是否禁用
  disabled: {
    type: Boolean,
    default: false
  },
  // 是否包括根结点
  hasRoot: {
    type: Boolean,
    default: false
  },
  // 是否多选
  multiple: {
    type: Boolean,
    default: false
  },
  // 展示方式  // 排版类型 横向cascade-selector 纵向tree-selector  cascade | tree
  uiType: {
    type: String,
    default: 'cascade'
  },
  // 是否支持模糊搜索
  filterable: {
    type: Boolean,
    default: false
  },
  // 对象形式 可配置v-model返回的对象内参数
  valueKey: String,
  validateField: Function,
  // 纯文本
  isPureText: Boolean
}

export function initValue (value) {
  return isEmpty(value) ? '-' : isEmpty(value.name) ? '-' : value.name
}
